// @flow
import { createAction } from 'redux-actions';

// The goal is to keep sagas and callbacks local to route
// When we enter a route we send associated sagas
// When we exit a route w

type RoutePayload = {
  saga: Generator<*, *, *>,
  sagaArgs?: Array<*>,
  cb?: void => void,
};

export const enterRoute = createAction(
  'ENTER_ROUTE',
  (payload: RoutePayload) => payload
);
export const exitRoute = createAction('EXIT_ROUTE');



// WEBPACK FOOTER //
// ./src/ducks/routeActions.js